<template>
    <div class="diagram-detail-top-panel">
        <div class="diagram-detail-top-info">
            <!-- 1. 顶部标题栏 -->
            <div class="diagram-d-title-bar dsp-flex" v-if="!diagramDetailEdited">
                <div class="title-side title-left" @click="clickBack">
                    <span class="title-back"><i class="iconfont icon-xiangzuo"></i></span>
                </div>
                <div class="title-middle">天时六爻</div>
                <!-- <div class="title-side title-right" >
                    <span><i class="iconfont icon-more"></i></span>
                </div> -->
            </div>
            <!-- 2. 顶部信息栏 -->
            <div class="diagram-detail-info" v-if="diagramBaseInfo && !diagramDetailEdited">
                <div class="diagram-d-i-item">
                    <div class="diagram-d-i-i-title">求测：</div>
                    <div class="diagram-d-i-i-info">{{diagramTitle == '' ? '未填写' : diagramTitle}}</div>
                    <div class="diagram-d-i-i-edit">
                        <span v-if="!diagramFromShare" class="edit-btn" @click="clickEdit"><span>编辑</span></span>
                        <span class="edit-btn" @click="clickDiagram"><span>起卦</span></span>
                    </div>
                </div>
                <div class="diagram-d-i-item">
                    <div class="diagram-d-i-i-title">时间：</div>
                    <div>{{diagramBaseInfo.timeStr+' '+diagramBaseInfo.timeWeek}}</div>
                </div>
                <div class="diagram-d-i-item">
                    <div class="diagram-d-i-i-title">干支：</div>
                    <div class="ganzhi" v-for="(sizhi, index) in diagramBaseInfo.siZhi" :key="sizhi+index">
                        <span :class="{'red': index == 1 || index == 2}">{{sizhi}}</span><span v-if="index == 3">（旬空：<span class="red">{{diagramBaseInfo.xunKong}}</span>）</span>
                    </div>
                </div>
                <div class="diagram-d-i-item">
                    <div class="diagram-d-i-i-title">神煞：</div>
                    <div class="diagram-d-i-i-shensha clearfix">
                        <span class="ss" v-for="(ss, index) in diagramBaseInfo.ssList" :key="ss+index">{{ss}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 3. 六爻信息栏 -->
        <div class="diagram-detail-d-info" v-if="diagramDetailInfo">
            <div class="diagram-d-d-i-item item-title1">
                <div class="item-1"></div>
                <div class="item-2"></div>
                <div class="item-3">{{diagramDetailInfo.oGua.gongStr+'宫：'+diagramDetailInfo.oGua.text+(diagramDetailInfo.oGua.describe != '' ? '('+diagramDetailInfo.oGua.describe+')' : '')}}</div>
                <div class="item-4"></div>
                <div class="item-5"></div>
                <div class="item-3">{{diagramDetailInfo.cGua.gongStr+'宫：'+diagramDetailInfo.cGua.text+(diagramDetailInfo.cGua.describe != '' ? '('+diagramDetailInfo.cGua.describe+')' : '')}}</div>
                <div class="item-7"></div>
            </div>
            <div class="diagram-d-d-i-item item-title2">
                <div class="item-1">六神</div>
                <div class="item-2">伏神</div>
                <div class="item-3">本<span class="title-space"></span>卦</div>
                <div class="item-4"></div>
                <div class="item-5"></div>
                <div class="item-6">变<span class="title-space"></span>卦</div>
                <div class="item-7"></div>
            </div>
            <div class="diagram-d-d-i-item" v-for="line in lineList" :key="line">
                <div class="item-1">{{diagramDetailInfo.liushen[line]}}</div>  <!--六神-->
                <div class="item-2"> <!--伏神-->
                    <span v-if="diagramDetailInfo.fushen.length > 0" class="title-sub red">{{diagramDetailInfo.fushen[line]}}</span>
                </div>
                <div class="item-3">    <!--本卦第N爻-->
                    <span class="title-span">{{diagramDetailInfo.oGua.liuqin[line]+diagramDetailInfo.oGua.najia[line]}}</span>
                    <diagram-line-item :itemType="diagramDetailInfo.oGua.yao[line] == 1 ? 'yang' : 'yin'"></diagram-line-item>
                    <div class="title-label">   <!--本卦旬空、暗动、月破-->
                        <span v-if="diagramDetailInfo.oGua.xk.other[line].xunkong" class="l-label l-gray">旬空</span>
                        <span v-if="diagramDetailInfo.oGua.xk.other[line].andong" class="l-label l-green">暗动</span>
                        <span v-if="diagramDetailInfo.oGua.xk.other[line].yuepo" class="l-label l-red">月破</span>
                    </div>
                </div>
                <div class="item-4">{{line == diagramDetailInfo.oGua.shi ? '世' : line == diagramDetailInfo.oGua.ying ? '应' : ''}}</div>      <!--本卦世应-->
                <div class="item-5">    <!--动爻-->
                    <span v-if="diagramDetailInfo.oGua.changed.indexOf(line) >= 0" class="title-icon"><i class="iconfont" :class="{'icon-unselected': diagramDetailInfo.oGua.yao[line] == 1, 'icon-guanbi': diagramDetailInfo.oGua.yao[line] == 0}"></i><i class="iconfont icon-arrow"></i></span>
                </div>      
                <div class="item-6">    <!--变卦第N爻-->
                    <span class="title-span">{{diagramDetailInfo.cGua.liuqin[line]+diagramDetailInfo.cGua.najia[line]}}</span>
                    <diagram-line-item :itemType="diagramDetailInfo.cGua.yao[line] == 1 ? 'yang' : 'yin'"></diagram-line-item>
                </div>
                <div class="item-7">{{line == diagramDetailInfo.cGua.shi ? '世' : line == diagramDetailInfo.cGua.ying ? '应' : ''}}</div>      <!--变卦世应-->
            </div>
        </div>
    </div>
</template>

<script>
import DiagramLineItem from '../../components/diagram/DiagramLineItem.vue'
export default {
    name: 'DiagramDetailTopPanel',
    components: { DiagramLineItem },
    computed: {
        diagramTitle() {
            return this.$store.state.diagram.diagramTitle;
        },
        diagramBaseInfo() {
            return this.$store.state.diagram.diagramBaseInfo;
        },
        diagramDetailInfo() {
            return this.$store.state.diagram.diagramDetailInfo;
        },
        diagramFromShare() {
            return this.$store.state.diagram.diagramFromShare;
        },
        diagramData() {
            return this.$store.state.diagram.diagramData;
        },
        diagramDetailEdited() {
            return this.$store.state.diagram.diagramDetailEdited;
        }
    },
    data() {
        return {
            lineList: [0, 1, 2, 3, 4, 5]
        }
    },
    methods:{
        clickBack() {
            this.$store.dispatch('diagram/resetDiagramInfo');
            // this.$store.state.diagram.curOrderIndex = 1;
            
            let curPath = this.$router.history.current.path;
            let fullPath = this.$router.history.current.fullPath;
            console.log('clickBack-----', fullPath)
            if(curPath.indexOf('embedded') != -1) {
                let pathArr = curPath.split('/').filter(text => {return text!=''&&text!='embedded'});
                let replaceText = '/'+pathArr.join('/');
                    fullPath = fullPath.replace(replaceText, '/diagramrecord');
                setTimeout(() => {
                    this.$router.replace(fullPath);
                }, 100);
            }else {
                this.$router.replace('/diagramrecord');
            }
        },
        clickEdit() {
            this.$store.dispatch('diagram/updateDiagramEditForm');

            let curPath = this.$router.history.current.path;
            let fullPath = this.$router.history.current.fullPath;
            console.log('clickEdit-----', fullPath)
            if(curPath.indexOf('embedded') != -1) {
                fullPath = fullPath.replace('/diagramdetail', '/diagramedit');
                setTimeout(() => {
                    this.$router.replace(fullPath);
                }, 100);
            }else {
                this.$router.replace('/diagramedit/'+this.diagramData.id);
            }
        },
        clickDiagram() {
            this.$store.dispatch('diagram/resetDiagramInfo');

            let curPath = this.$router.history.current.path;
            let fullPath = this.$router.history.current.fullPath;
            console.log('clickDiagram-----', fullPath)
            if(curPath.indexOf('embedded') != -1) {
                let pathArr = curPath.split('/').filter(text => {return text!=''&&text!='embedded'});
                let replaceText = '/'+pathArr.join('/');
                    fullPath = fullPath.replace(replaceText, '/diagram');
                setTimeout(() => {
                    this.$router.replace(fullPath);
                }, 100);
            }else {
                this.$router.replace('/diagram');
            }
        },
    }
}
</script>
